import { PageRef } from 'providers/page-ref';

export type ChangelogPageParams = {};

export const IChangelogPage: PageRef<ChangelogPageParams, void> = {
  pageName: 'ChangelogPage',
} as PageRef<ChangelogPageParams, void>;
